import { DataSource } from 'app/components/data/DataSource/DataSource'

/**
 * LocalDataSource for data that does not require http requests
 */
export class LocalDataSource<T extends object> extends DataSource<T> {

  createRecord(record: T): Promise<T> {
    this.config.data.push(record)

    this.sync()

    return Promise.resolve(record)
  }

  removeRecord(record: T): Promise<boolean> {
    const recordIndex = this.config.data.indexOf(record)

    if (recordIndex >= 0) {
      this.config.data.splice(recordIndex, 1)

      this.sync()

      return Promise.resolve(true)
    }

    return Promise.reject(false)
  }

  protected getCount(): Promise<number> {
    return this.getAllRecords()
      .then((records) => this.getRecordsWithSearchWord(records).length)
  }

  protected getRecords(): Promise<T[]> {
    return this.getAllRecords()
      .then((records) => this.searchAndSortAndFilter(records))
  }

  protected getRecordsAndCount(): Promise<[T[], number]> {
    return Promise.all([
      this.getRecords(),
      this.getCount()
    ])
  }

  protected getAllRecords(): Promise<T[]> {
    return Promise.resolve<T[]>(this.config.data)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Local/index.ts